// ReactionItem.tsx

import { FC } from 'react';
import EmojiIcon, { EmojiOption } from 'components/EmojiIcon';
import styles from './styles.module.less';

interface ReactionItemProps {
  emoji: EmojiOption;
  count: number;
  isUserReaction: boolean;
  onClick: (emojiId: string) => void;
  isPulsingUp?: boolean;
  isPulsingDown?: boolean;
  className?: string;
}

const ReactionItem: FC<ReactionItemProps> = ({
  emoji,
  count,
  isUserReaction,
  onClick,
  isPulsingUp,
  isPulsingDown,
  className = '',
}) => {
  const reactionClasses = [
    styles.reactionItem,
    isUserReaction ? styles.reactionItemActive : '',
    isPulsingUp ? styles.reactionItemPulsingUp : '',
    isPulsingDown ? styles.reactionItemPulsingDown : '',
    className,
  ].join(' ');

  return (
    <button type="button" key={emoji.id} className={reactionClasses} onClick={() => onClick(emoji.id)}>
      <EmojiIcon symbol={emoji.native} size={18} />
      {count > 0 && (
        <span className={className.includes(styles.reactionButton) ? styles.reactionCountBadge : undefined}>{count}</span>
      )}
    </button>
  );
};

export default ReactionItem;
